import {
  CATALOG_BOOK_LIST_SET_DATA,
  CATALOG_BOOK_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  subscriptionId: null,
  totalBookCount: null,
  bookType: null,
};

export default function catalogBookList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_BOOK_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_BOOK_LIST_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
